export const SystemGrant = ['admin', 'user']
